import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { OpportunityStage, OpportunityStageCreate, OpportunityStageFilter } from '../data/opportunityStage';

export function createOpportunityStageService(client: AxiosInstance) {
  return createCrudService<OpportunityStage, OpportunityStageCreate, OpportunityStageFilter>(
    client,
    '/crm/OpportunityStage',
    'id',
  );
}

export type OpportunityStageService = CrudService<OpportunityStage, OpportunityStageCreate, OpportunityStageFilter>;
